<div class="card p-3 mb-2">
  <div class="row g-3 align-items-center">

    <div class="col-auto">
      <img
        [src]="'https://www.thespruce.com/thmb/BpZG-gG2ReQwYpzrQg302pezLr0=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/Stocksy_txp3d216bb1tUq300_Medium_4988078-56c96ac19def4bf8ba430cf5063b6b38.jpg'"
        alt="Apartment photo"
        class="rounded"
        height="180"
        style="object-fit: cover;"
        width="180"
      />
    </div>

    <div class="col d-flex ms-2 flex-column">
      <div class="d-flex justify-content-between align-items-start gap-4">
        <div>
          <h4 class="mb-1 fw-bold">{{ apartment?.apartmentName || 'Apartment' }}</h4>
          <p class="text-muted mb-1">
            <i class="la la-building"></i>
            {{ apartment?.building?.name }}
          </p>
        </div>

        <span [type]="apartment?.unitStatus" apartmentUnitStatusBadge class="ml-auto"></span>
      </div>

      <h6 class="mt-4 fw-bold">{{ 'APARTMENT.DESCRIPTION' | translate }}</h6>

      <p class="mb-2 text-muted">
        {{ apartment?.notes || '-' }}
      </p>

      <div class="d-flex justify-content-start gap-2">
        <button (click)="onEdit()" class="btn btn-primary btn-sm">
          <i class="las la-pen fs-18 align-middle"></i>
          {{ 'METER.APARTMENT' | translate }}
          {{ 'ACTIONS.UPDATE' | translate }}
        </button>
      </div>
    </div>

    <div class="col-auto meta-info">
      <div class="row gx-2">
        <div class="col-lg-6 col-12">
          <card
            type="no-title"
            [title]="translateService.instant('PROPERTY.HOUSENUMBER')"
            [value]="apartment?.building?.addressBook?.houseNumber"
            icon="ri-hotel-line"
            [isLoading]="!apartment"
          />
        </div>

        <div class="col-lg-6 col-12">
          <card
            type="no-title"
            [title]="translateService.instant('APARTMENT.SIZE_SQM')"
            [value]="apartment?.size"
            icon="ri-ruler-line"
            [isLoading]="!apartment"
          />
        </div>

        <div class="col-lg-4 col-12">
          <card
            type="no-title"
            [title]="translateService.instant('APARTMENT.FLOOR')"
            [value]="apartment?.floor"
            icon="ri-menu-5-fill"
            [isLoading]="!apartment"
          />
        </div>

        <div class="col-lg-8 col-12">
          <card
            type="no-title"
            [title]="translateService.instant('APARTMENT.ASSIGNED_METERS')"
            [value]="apartment?.meters?.length"
            icon="ri-calculator-line"
            [isLoading]="!apartment"
          />
        </div>

        <div class="col-lg-7 col-12">
          <card
            type="no-title"
            [title]="translateService.instant('APARTMENT.NUMBER_OF_RESIDENTS')"
            [value]="apartment?.numberOfRenters"
            icon="ri-group-line"
            [isLoading]="!apartment"
          />
        </div>
        <div class="col-lg-5 col-12">
          <card
            [isLoading]="!apartment"
            [title]="translateService.instant('APARTMENT.VACANT_ROOMS')"
            [value]="apartment?.vacantRoomsCount"
            icon="ri-door-open-line"
            type="no-title"
          />
        </div>
      </div>
    </div>
  </div>
</div>

